<template>
	<div class="compContentDetail">
		<div class="closeLine">
			<div></div>
			<img class="closeIcon" @click="close" src="../../assets/img/content/close.png"/>
		</div>
		<div class="box">
			<div class="userLine">
				<div class="userLineL">
					<img v-if="detail.userId" class="avatar" :src="$public.getMemberPic(detail.userId)"/>
					<div class="userMsg">
						<div class="userName">{{detail.userName}}</div>
						<div class="userNum">
							<span style="padding-right: 16px;">{{detail.userMobile}}</span>
							<span style="color:#91919F;">{{detail.release}}</span>
						</div>
					</div>
				</div>
				<div class="userLineR">
					<div class="userLineRItem" style="color:#577BFF;cursor: pointer;" @click="set_dongtai(detail)">设置数据</div>
					<div class="userLineRItem">阅读 {{detail.seeCount}}</div>
					<div class="userLineRItem">评论 {{detail.commentCount}}</div>
					<div class="userLineRItem">点赞 {{detail.likeCount}}</div>
					<div class="userLineRItem">分享 {{detail.shareCount}}</div>
					<div class="userLineRItem">收藏 {{detail.collectCount}}</div>
				</div>
			</div>
			<div class="contentBox">
				<div class="tagLine">
					<div class="tagItem" v-for="item in detail.topicList" :key="item.topicId">
						<img class="tagIcon" src="../../assets/img/member/tag.png"/>
						<div class="tagText"> {{item.topicName}} </div>
					</div>
				</div>
				<!-- 动态 -->
				<div v-if="contentType==='动态'">
					<div v-if="detail.type===1">
						<div class="wordLine">
							<div class="word">
								{{detail.content}}
							</div>
						</div>
						<div class="imgLine">
							<img v-for="(item,index) in detail.imgs" :key="index" class="img" :src="item"/>
						</div>
					</div>
					<div v-if="detail.type===2">
						<div class="wordLine">
							<div class="word">
								{{detail.content}}
							</div>
						</div>
						<div class="imgLine" >
							封面图：<img v-for="(item,index) in detail.imgs" :key="index" class="img" :src="item"/>
						</div>
						<div class="imgLine">
							<!-- @touchend="toSwiperPage(index)"
							@touchmove="touchMoveState = true" -->
							<video
								controls
								autoplay
								loop
								muted
								style="width:600px;"
							>
								<source :src="detail.video" type="video/mp4">
								Your browser does not support the video tag.
							</video>
						</div>
					</div>
					<div v-if="detail.type===3">
						<div class="wordLine">
							<div class="word">
								{{detail.content}}
							</div>
						</div>
						<div class="imgLine" >
							<img v-for="(item,index) in detail.imgs" :key="index" class="img" :src="item"/>
						</div>
						<div class="imgLine">
							打卡地：{{detail.punchCardName}}
						</div>
					</div>
					<div v-if="detail.type===4">
						<div class="wordLine">
							<div class="word">
								{{detail.content}}
							</div>
						</div>
						<div class="imgLine" >
							<img v-for="(item,index) in detail.imgs" :key="index" class="img" :src="item"/>
						</div>
						<div class="wordLine">
							<div class="word">
								{{detail.contentNote}}
							</div>
						</div>
					</div>
					<div v-if="detail.type===5">
						<div class="wordLine">
							<div class="word">
								{{detail.content}}
							</div>
						</div>
						<div class="imgLine" >
							<img v-for="(item,index) in detail.imgs" :key="index" class="img" :src="item"/>
						</div>
						<div class="wordLine">
							<div class="word richText" v-html="detail.contentNote">
							</div>
						</div>
					</div>
				</div>
				<!-- 文章 -->
				<div v-if="contentType==='文章'">
					<div class="wordLine">
						<div class="word">
							{{detail.title}}
						</div>
					</div>
					<div class="wordLine">
						<div class="word richText" v-html="detail.content">
						</div>
					</div>
				</div>
			</div>
			<div class="navLine" >
				<div style="display: flex;">
					<div v-if="detail.type===4" class="navItem" :class="curNavIndex===4?'active':''" @click="changeCurNavIndex(4)">
						回答问题
						<img v-if="curNavIndex===4" class="activeIcon" src="../../assets/img/content/navActive.png"/>
					</div>
					<div class="navItem" :class="curNavIndex===0?'active':''" @click="changeCurNavIndex(0)">
						评论内容
						<img v-if="curNavIndex===0" class="activeIcon" src="../../assets/img/content/navActive.png"/>
					</div>
					<div class="navItem" :class="curNavIndex===1?'active':''" @click="changeCurNavIndex(1)">
						点赞人员
						<img v-if="curNavIndex===1" class="activeIcon" src="../../assets/img/content/navActive.png"/>
					</div>
					<div class="navItem" :class="curNavIndex===2?'active':''" @click="changeCurNavIndex(2)">
						分享人员
						<img v-if="curNavIndex===2" class="activeIcon" src="../../assets/img/content/navActive.png"/>
					</div>
					<div class="navItem" :class="curNavIndex===3?'active':''" @click="changeCurNavIndex(3)">
						收藏人员
						<img v-if="curNavIndex===3" class="activeIcon" src="../../assets/img/content/navActive.png"/>
					</div>
				</div>
				<div style="display: flex;justify-content: flex-end;">
				</div>
			</div>
			<div class="tableBox">
				<compContentAnswer v-if="curNavIndex===4" :contentId="id" :contentType="contentType"></compContentAnswer>
				<compContentPinglun v-if="curNavIndex===0" :contentId="id" :contentType="contentType"></compContentPinglun>
				<compContentLike v-if="curNavIndex===1" :contentId="id" :contentType="contentType"></compContentLike>
				<compContentShare v-if="curNavIndex===2" :contentId="id" :contentType="contentType"></compContentShare>
				<compContentCollect v-if="curNavIndex===3" :contentId="id" :contentType="contentType"></compContentCollect>
			</div>
		</div>
		<!-- 设置数据 -->
		<div v-if="drawerSetDongtai_state">
			<drawerSetDongtai :commentCount="curDongtai.commentCount" :likeCount="curDongtai.likeCount" :seeCount="curDongtai.seeCount" :shareCount="curDongtai.shareCount" :collectCount="curDongtai.collectCount" @submit="submit_drawerSetDongtai"></drawerSetDongtai>
		</div>
	</div>
</template>

<script>
	import compContentAnswer from "./compContentAnswer.vue"
	import compContentPinglun from "./compContentPinglun.vue"
	import compContentLike from "./compContentLike.vue"
	import compContentShare from "./compContentShare.vue"
	import compContentCollect from "./compContentCollect.vue"
	import drawerSetDongtai from "@/components/pinglun/drawer_setDongtai.vue"
	export default {
		components:{compContentAnswer,compContentPinglun,compContentLike,compContentShare,compContentCollect,drawerSetDongtai},
		data() {
			return {
				detail:{},
				
				curNavIndex:0,
				
				pinglunContent:'',
				// 设置数据
				drawerSetDongtai_state:false,
				curDongtai:{},
			}
		},
		computed:{
			
		},
		props:{
			id:{
				default:''
			},
			contentType:{
				default:''
			}
		},
		created(){
			
		},
		mounted(){
			this.getDetail();
		},
		methods:{
			close(){
				this.$emit("submit",{type:'close'})
			},
			changeCurNavIndex(i){
				this.curNavIndex=i;
			},
			// 获取详情
			getDetail(){
				if(this.contentType==='动态'){
					let params = {
						id:this.id,
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_AppAdmin+'/api/Dynamic/GetDynamic', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.detail = res.data;
						}
					})
				}else if(this.contentType==='文章'){
					let params = {
						id:this.id,
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_AppAdmin+'/api/Article/GetArticle', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.detail = res.data;
						}
					})
				}
			},
			set_dongtai(row){
				this.curDongtai = row;
				this.drawerSetDongtai_state = true;
			},
			submit_drawerSetDongtai(obj){
				this.drawerSetDongtai_state = false;
				if(obj.type==='success'){
					if(this.contentType==='动态'){
						let params = {
							"id": this.curDongtai.id,
							"commentCount": parseInt(obj.data.commentCount),
							"likeCount": parseInt(obj.data.likeCount),
							"seeCount": parseInt(obj.data.seeCount),
							"shareCount": parseInt(obj.data.shareCount),
							"collectCount": parseInt(obj.data.collectCount),
						}
						let loading = this.$loading()
						this.$http.post(process.env.VUE_APP_AppAdmin+'/api/Dynamic/UpdateDynamicData', params).then(res => {
							loading.close();
							if (res.code == 0) {
								this.$message({
									message: '操作成功',
									type: 'success'
								});
								this.getDetail()
							}
						})
					}else if(this.contentType==='文章'){
						let params = {
							"id": this.curDongtai.id,
							"commentCount": parseInt(obj.data.commentCount),
							"likeCount": parseInt(obj.data.likeCount),
							"seeCount": parseInt(obj.data.seeCount),
							"shareCount": parseInt(obj.data.shareCount),
							"collectCount": parseInt(obj.data.collectCount),
						}
						let loading = this.$loading()
						this.$http.post(process.env.VUE_APP_AppAdmin+'/api/Article/UpdateArticleData', params).then(res => {
							loading.close();
							if (res.code == 0) {
								this.$message({
									message: '操作成功',
									type: 'success'
								});
								this.getDetail()
							}
						})
					}
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.compContentDetail{
		.closeLine{
			display: flex;justify-content: space-between;
			.closeIcon{
				width:80px;height: 44px;cursor: pointer;
			}
		}
		.box{
			background-color: #fff;margin-top:16px;border-radius: 16px;padding:32px 0 10px 32px;box-sizing: border-box;
			.userLine{
				display: flex;justify-content: space-between;padding-right: 32px;
				.userLineL{
					display: flex;
					.avatar{
						width:56px;height: 56px;margin-right: 16px;border-radius: 50%;
					}
					.userMsg{
						.userName{
							font-size: 14px;color:$color333;font-weight: bold;padding: 5px 0 15px 0;
						}
						.userNum{
							font-size: 14px;color:$color333;
						}
					}
				}
				.userLineR{
					display: flex;
					.userLineRItem{
						font-size: 14px;color:$color333;margin-left:32px;
					}
				}
			}
			.contentBox{
				margin-left:72px;border-top:1px solid #F2F2F2;margin-top:8px;
				.tagLine{
					display: flex;padding-top:15px;
					.tagItem{
						background-color: #F7F9FA;border-radius: 12px;margin-right: 20px;display: flex;height: 22px;padding:3px 10px 3px 3px;box-sizing: border-box;line-height: 16px;
						.tagIcon{
							width:16px;height: 16px;margin-right: 5px;
						}
						.tagText{
							font-size: 12px;color:#4062E7;
						}
					}
				}
				.wordLine{
					padding-top:15px;padding-right: 50px;
					.word{
						font-size: 14px;color:$color333;line-height: 22px;
						&.richText{
							font-size: 14px;
							::v-deep img{
								max-width: 400px;
							}
						}
					}
				}
				.imgLine{
					padding-top:20px;
					.img{
						width:104px;height: 104px;margin-right: 4px;
					}
				}
			}
			.navLine{
				margin-left:72px;padding-top:30px;display: flex;justify-content: space-between;border-bottom:1px solid #F2F2F2;background-color: #fff;position: sticky;top:-17px;z-index: 1;
				.navItem{
					font-size: 16px;color:$color333;margin-right: 50px;cursor: pointer;
					&.active{
						color:#577BFF;
					}
					.activeIcon{
						width:100%;height: 7px;display: block;margin:10px auto -1px;
					}
				}
			}
			.tableBox{
				margin-left:72px;margin-right: 48px;
			}
		}
	}
</style>

